<template>
  <div class="coupon-package-block">
    <div class="package-bg">
      <img src="@/static/image/coupon-package/bg_top.png" />
    </div>
    <div class="package-logo-top">
      <img src="@/static/image/coupon-package/logo_2.png" />
    </div>
    <div class="package-rule" @click="popupShow = true">
      <img src="@/static/image/coupon-package/icon_rule.png" />
    </div>
    <div class="package-share" v-if="isApp" @click="share">
      <img src="@/static/image/coupon-package/icon_share.png" />
    </div>
    <div class="package-activity-list">
      <div
        v-for="(item, index) in activityList"
        :key="index"
        class="package-activity-list-item"
        @click="handlerActivity(item)"
      >
        <img :src="item.activityImage" />
      </div>
    </div>
    <div class="package-logo-bottom">
      <img src="@/static/image/coupon-package/logo_1.png" />
    </div>
  </div>
  <Popup
    :style="{ height: '126vw', width: '89vw', backgroundColor: 'rgba(0, 0, 0, 0)' }"
    v-model:show="popupShow"
  >
    <div>
      <div class="popup-content">
        <div class="rule-box">
          <div class="rule-header">活动规则</div>
          <div class="rule-content">&nbsp;</div>
          <div class="rule-content">参与本活动前，请仔细阅读活动规则。凡参与本活动，即视为您已阅读、理解并同意本活动规则中的全部内容。</div>
          <div class="rule-title">活动时间</div>
          <div class="rule-content">即日起-2024年10月20日23:59:59</div>
          <div class="rule-title">购买说明</div>
          <div class="rule-content">
            活动期间，每个账户两种省钱套餐卡限各购买一次，支付费用购买成功的用户，自购买成功之日每个套餐卡对应优惠券将一次性发放到购买账户，一经购买不支持退款
          </div>
          <div class="rule-title">省钱套餐卡使用说明</div>
          <div class="rule-content">
            套餐一：满2999元-2999元优惠券1张，用车时间日常及中秋、国庆、元旦、春节、清明、劳动、端午7大法定节假日通用；满2999元-1800元优惠券5张，用车时间除国庆、春节、五一不可用，其他时段通用；本套餐取还车城市限二线城市使用（杭州、成都、武汉、三亚）；<br />
            套餐二：满2999元-2999元优惠券1张，用车时间日常及中秋、国庆、元旦、春节、清明、劳动、端午7大法定节假日通用；满2999元-1400元优惠券5张，用车时间除国庆、春节、五一不可用，其他时段通用；本套餐取还车城市限一线城市使用（北京、上海、广州、深圳）；<br />
            以上优惠券仅限作为车辆订阅租赁费用使用，自发放之日起有效期至2024年12月31日，可在极氪订阅App/微信/支付宝小程序下单使用；过期未使用失效，不可转赠、不可折现、不退不换，不与其他优惠同享，适用车型为极氪001（满7天可用）；<br />
          </div>
          <div class="rule-title">开票说明</div>
          <div class="rule-content">
            省钱套餐卡购买成功后，使用套餐中优惠券下单，还车后可以申请开票；使用满2999-2999元优惠券下单还车后开2999元发票，使用满2999-1800元优惠券下单还车后开1199+100元发票，使用满2999-1400元优惠券下单还车后开1599+100元发票；申请开票请联系官方客服：400-003-6036；
          </div>
          <!-- <div class="rule-title"></div> -->
          <div class="rule-content">&nbsp;</div>
          <div class="rule-content">
            请您知晓，本活动发放优惠券需要收集您的极氪订阅注册账号信息，若您不同意我们收集您的上述个人信息，您将无法参与我们的活动购买省钱套餐卡。也请您放心，我们会合规使用和存储您的个人信息，不会共享给任何第三方；
          </div>
          <!-- <div class="rule-title"></div> -->
          <div class="rule-content">&nbsp;</div>
          <div class="rule-content">
            对于活动详情、活动规则有任何疑问，可咨询极氪订阅官方客服，客服热线400-003-6036。
          </div>
        </div>
      </div>
      <img
        class="icon-close"
        @click="popupShow = false"
        src="@/static/image/coupon-package/icon_close.png"
      />
    </div>
  </Popup>
  <Popup :style="{ backgroundColor: 'rgba(0, 0, 0, 0)' }" v-model:show="popupShow2">
    <div class="popup-message">
      <div class="popup-title">{{ activityEnd ? '活动已结束！' : '活动尚未开始' }}</div>
      <div v-if="activityEnd" class="popup-subtitle">您来晚啦，活动已结束...</div>
    </div>
  </Popup>
</template>
<script setup>
import { ref } from 'vue'
import { Popup, Toast } from 'vant'
import Ditto from '@zeekr-f2e/zeekr-ditto'
import { useRouter } from 'vue-router'
import * as api from '@/api/otherOrder'
import './index.scss'
const ua = window.navigator.userAgent.toLowerCase()
const popupShow = ref(false)
const popupShow2 = ref(false)
const isApp = ref(/ZEEKR-APP-(\w+)/.test(navigator.userAgent)) // 是否处于极氪订阅app当中
const hasAliApp = ref(ua.indexOf('aliapp') > -1)
const hasWx = ref(ua.match(/MicroMessenger/i) == 'micromessenger')
const router = useRouter()
const paying = ref(false)
const realPhone = ref('')
const phone = ref('')
const vipCode = ref('')
const headImg = ref('')

const activityList = ref([])
const activityEnd = ref(false)
const fetchActivity = () => {
  api
    .queryRepurchaseCoupon({
      vipCode: vipCode.value
    })
    .then(res => {
      if (res.data.code === '0' && res.data.body) {
        activityList.value = res.data.body
      } else {
        Toast(res.data.msg)
      }
    })
    .catch(err => {
      console.log('err', err)
      Toast(err.message)
    })
}
const getUserInfo = () => {
  Ditto.registerParams('common_js.getUserInfo').then(res => {
    if (res) {
      console.log('getUserInfo', res)
      if (res.vipCode) {
        vipCode.value = res.vipCode
        realPhone.value = res.realPhone || ''
        phone.value = res.phone || ''
        headImg.value = res.headImg || ''
      }
      fetchActivity()
    }
  })
}
// 在app中 获取用户信息
if (isApp.value) {
  getUserInfo()
} else {
  fetchActivity()
}

const handlerActivity = item => {
  if (item.receiveStatus !== 0) {
    toSub()
  } else {
    if (item.activityStatus === 3) {
      startPayCenter(item.id)
    } else {
      if (item.activityStatus === 5 || item.activityStatus === 4) {
        activityEnd.value = true
      }
      popupShow2.value = true
    }
  }
}
// 付款
const startPayCenter = activityId => {
  if (isApp.value) {
    // 处于app中且未登录
    if (!vipCode.value) {
      const _data = {
        path: 'subscription_biz_mine.ZUSubscriptionLoginViewController'
      }
      Ditto.openNative({
        protocol: 'app://route/openNative?path=/subscription/login&data=' + JSON.stringify(_data)
      })
      return
    }
    // 正在支付中
    if (paying.value) return
    paying.value = true
    api
      .payRepurchaseCoupon({
        activityId, // 订阅增值业务订单订单类型，1-网易严选联合会员购买
        channelSource: 1, // 渠道，1=订阅app，2=微信小程序，3=极氪app，4=支付宝小程序
        phone: phone.value, // 手机号，未加密
        terminalType: 1, // 终端类型：1-APP，2-PC，3-微信小程序，4-Pad，5-支付宝小程序
        vipCode: vipCode.value // 用户vipCode
      })
      .then(
        res => {
          console.log('startPayCenter', res)
          if (res.status === 200 && res.data.code === '0') {
            Ditto.registerParams('subscription.startPayCenter', res.data.body).then(
              () => {},
              err => {
                Toast('您已取消购买')
              }
            )
          } else {
            Toast((res.data && res.data.msg) || '您已取消购买')
            fetchActivity()
          }
          paying.value = false
        },
        () => {
          Toast('您已取消购买')
          paying.value = false
        }
      )
  } else {
    // 未处于app中
    router.push({
      name: 'DownloadGuidance'
    })
  }
}

// 前往订阅页
const toSub = () => {
  if (hasAliApp.value) {
    // 支付宝内
    my.navigateBack()
    my.redirectTo({ url: '/pages/index/index' })
  } else if (hasWx.value) {
    // 微信内
    if (!isIos) {
      wx.miniProgram.navigateBack()
    }
    wx.miniProgram.switchTab({ url: '/pages/subscribe/subscribe' })
  } else {
    // 默认认为是app
    Ditto.openNative({
      protocol:
        'app://route/openNative?path=/subscription/subs&data=' +
        JSON.stringify({
          path: '/subscription/subs',
          type: '2'
        })
    })
  }
}
// app分享
const share = () => {
  Ditto.registerParams('common_js.shareSelector', {
    title: '超值省钱套餐卡来啦！',
    des: '首单0元享001七天订阅权，节假日可用！',
    url: process.env.VUE_APP_ZEEKR_WEB_ADDRESS + '/couponPackage',
    shareType: 3,
    imgUrl:
      'https://hhstaticource.oss-cn-hangzhou.aliyuncs.com/web-static-source/subscribe/images/share_375.jpg'
    // // 标题
    // var title:String?
    // // 副标题
    // var des:String?
    // // h5链接
    // var url:String?
    // // 缩略图
    // var imgUrl:String?
    // // 1文字 2图片 3H5
    // var shareType:Int?
    // // 是否需要在分享按钮上方预览分享的图片
    // var showImg: Bool?
  })
}
</script>
